.shell {
  display: grid;
  grid-template-columns: var(--sidebar-width) minmax(0, 1fr);
  min-height: 100dvh;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px 16px;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-subtle);
}

.brand {
  padding: 4px 8px;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.link {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 12px;
  color: var(--text-secondary);
  border-left: 2px solid transparent;
  transition:
    color var(--dur-fast) var(--ease-out),
    background-color var(--dur-fast) var(--ease-out);
}

.link:hover {
  color: var(--text-primary);
  background: var(--bg-elevated);
}

.active {
  color: var(--text-primary);
  border-left-color: var(--accent);
  background: var(--bg-elevated);
}

.account {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle);
}

.who {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
}

.name {
  font-weight: 600;
}

.role {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.themes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: 1px solid var(--border-primary);
}

.theme {
  min-height: 36px;
  padding: 0 8px;
  background: transparent;
  border: 0;
  border-right: 1px solid var(--border-primary);
  font-size: 0.875rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-out);
}

.theme:last-child {
  border-right: 0;
}

.theme:hover {
  background: var(--bg-elevated);
}

.theme[aria-pressed='true'] {
  background: var(--bg-elevated);
  color: var(--text-primary);
  box-shadow: inset 0 -2px 0 var(--accent);
}

.logout {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 12px;
  background: transparent;
  border: 0;
  color: var(--text-secondary);
  cursor: pointer;
  text-align: left;
}

.logout:hover {
  color: var(--text-primary);
  background: var(--bg-elevated);
}

.main {
  min-width: 0;
  padding: clamp(20px, 4vw, 48px);
}

@media (max-width: 800px) {
  .shell {
    grid-template-columns: minmax(0, 1fr);
  }

  .sidebar {
    position: static;
    height: auto;
    gap: 16px;
    padding: 16px;
    border-right: 0;
    border-bottom: 1px solid var(--border-subtle);
  }

  .nav {
    flex-direction: row;
  }

  .account {
    margin-top: 0;
  }
}
